import { CheckCircleFilled, CloseCircleFilled, EditOutlined } from "@ant-design/icons";
import { Col, Row, Tooltip, Typography } from "antd";
import { EDITABLE_VAT_STATUSES } from "features/Order/constants";
import { useOrderPermissions } from "hooks/order";
import { t } from "i18next";
import { useState } from "react";
import ModalUpdateVatInfo from "../ModalUpdateVatInfo";

/**
 * Khối "Xuất hóa đơn VAT" ở màn Chi tiết đơn hàng, kèm entry point sửa thông tin xuất VAT.
 * Tách khỏi `InfoAgent` để state pop up không phải nằm trong component ~300 dòng đó.
 */
const VatExportInfo = ({ dataInfoAgent, order, onRefetch }) => {
  const {
    vat,
    vatAllOrder,
    vatTaxIDNumber,
    vatCompanyName,
    vatEmail,
    vatAddress,
    customerVatEmail,
    vatCustomerName,
    customerVatIDNumber,
    customerVatAddress,
    orderReconciliationStatus,
  } = dataInfoAgent;

  const [visibleUpdateVat, setVisibleUpdateVat] = useState(false);
  const { canUpdateVatInfo } = useOrderPermissions();

  // Luôn hiện icon, khoá kèm lý do thay vì ẩn: Sales thiếu quyền cần biết tính năng có tồn tại để
  // đi xin quyền. KHÔNG chặn theo `orderReconciliationStatus` — BE tạo bản ghi đối soát ngay lúc
  // tạo đơn khách hàng qua App Đại lý, chặn theo nó là khoá cả lớp đơn đó ở mọi trạng thái.
  const getDisabledReason = () => {
    if (!canUpdateVatInfo) return t("v2.order.detail.vatExportInfo.disabledByPermission");
    if (!EDITABLE_VAT_STATUSES.includes(order?.status)) return t("v2.order.detail.vatExportInfo.disabledByStatus");
    return null;
  };

  const disabledReason = getDisabledReason();

  return (
    <>
      <Row gutter={[16, 8]}>
        <Col span={24}>
          <Row justify="space-between" align="middle" wrap={false}>
            <Col>
              <Typography.Text strong style={{ color: "#052987" }}>
                {t("cart.vatAllOrderLabel")}
              </Typography.Text>
            </Col>
            <Col>
              <Tooltip title={disabledReason}>
                <EditOutlined
                  onClick={disabledReason ? undefined : () => setVisibleUpdateVat(true)}
                  style={{
                    color: disabledReason ? "#9CADC4" : "#2563EB",
                    fontSize: 16,
                    cursor: disabledReason ? "not-allowed" : "pointer",
                  }}
                />
              </Tooltip>
            </Col>
          </Row>
        </Col>

        <Col span={10}>
          {vat ? (
            <CheckCircleFilled style={{ color: "#00AB78" }} />
          ) : (
            <CloseCircleFilled style={{ color: "#D2434D" }} />
          )}
          <Typography.Text style={{ marginLeft: "8px" }}>{t("order.orderDetail.exportVat")}</Typography.Text>
        </Col>

        <Col span={14}>
          {vatAllOrder ? (
            <CheckCircleFilled style={{ color: "#00AB78" }} />
          ) : (
            <CloseCircleFilled style={{ color: "#D2434D" }} />
          )}
          <Typography.Text style={{ marginLeft: "8px" }}>
            {t("order.orderDetail.exportVatForAllOrders")}
          </Typography.Text>
        </Col>

        <Col span={10}>
          <Typography.Text strong>{t("order.orderDetail.taxCode")}</Typography.Text>
        </Col>
        <Col span={14}>
          <Typography.Text strong style={{ color: "#052987" }}>
            {orderReconciliationStatus ? customerVatIDNumber : vatTaxIDNumber}
          </Typography.Text>
        </Col>

        <Col span={10}>
          <Typography.Text strong>{t("order.orderDetail.companyName")}</Typography.Text>
        </Col>
        <Col span={14}>
          <Typography.Text strong style={{ color: "#052987" }}>
            {orderReconciliationStatus ? vatCustomerName : vatCompanyName}
          </Typography.Text>
        </Col>

        <Col span={10}>
          <Typography.Text strong>Email</Typography.Text>
        </Col>
        <Col span={14}>
          <Typography.Text strong style={{ color: "#052987" }}>
            {orderReconciliationStatus ? customerVatEmail : vatEmail}
          </Typography.Text>
        </Col>

        <Col span={10}>
          <Typography.Text strong>{t("order.orderDetail.addressInBill")}</Typography.Text>
        </Col>
        <Col span={14}>
          <Typography.Text strong style={{ color: "#052987" }}>
            {orderReconciliationStatus ? customerVatAddress : vatAddress}
          </Typography.Text>
        </Col>
      </Row>

      <ModalUpdateVatInfo
        visible={visibleUpdateVat}
        onClose={() => setVisibleUpdateVat(false)}
        order={order}
        onRefetch={onRefetch}
      />
    </>
  );
};

export default VatExportInfo;
